import { BehaviorSubject, Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { RouterStateSnapshot } from '@angular/router';
import { API } from 'src/app/configs';
import { HttpService } from 'src/app/core/http/http.service';
import { AdUtils } from 'src/app/shared/utils/ad.utils';
import { GeneralService } from 'src/app/shared/services/general.service';
import { AdService } from 'src/app/shared/services/ad.service';
import { DefaultPromise } from 'src/app/shared/models/ad';
import { AppLoadingService } from 'src/app/shared/services/apploading.service';
import { deepCopy } from '@angular-devkit/core/src/utils/object';

@Injectable({
    providedIn: 'root'
})

export class AvailableService {

    private companieSel;

    private data = new BehaviorSubject<any>(null);
    data$ = this.data.asObservable();

    private changed = new BehaviorSubject<any>(null);
    changed$ = this.changed.asObservable();

    _data :any ={};

    indexConfig :any ={};

    mode = '';
    readjustmentMode = '';
    
    

    protected companieSelSubscription: Subscription;

    constructor(
        protected httpService: HttpService,
        protected adUtils: AdUtils,
        protected gs: GeneralService,
        protected adService : AdService,
        protected als : AppLoadingService
    ) {
        this.companieSelSubscription = this.gs.companiesSel$.subscribe(result => {
            this.companieSel = result;
          });
    }

    async loadAd(id):Promise<any>{
        return this.adService.loadAd(id, this.companieSel)
            .then(result => {
                let data = this.setData(this.adService.adjustAds([result])[0]);
                return new DefaultPromise(data).getData();
            });
    }

    saveAvailable(nextState:RouterStateSnapshot = null, unpublish = false) {
        let data = this.data.getValue();

        let units = JSON.parse(JSON.stringify(data.data.units))
            .filter(item => item?.changed === true)
            .map(item => {
                if(this.mode == 'readjustment'){
                    if(item?.amountReadjustment)
                        item.amount = (typeof item?.amountReadjustment != 'string')? item?.amountReadjustment?.toFixed(2) : item?.amountReadjustment;

                    if(item?.amountIndexReadjustment)
                        item.amountIndex = item.amountIndexReadjustment;

                    if(!parseFloat(item.amountIndex))
                        delete item.amountIndex;

                    if(typeof item?.amountIndex != 'string')
                        item.amountIndex = item.amountIndex?.toFixed(6);
                }
                Object.keys(item).filter(k => {
                    if(['id', 'amount', 'amountOld', 'amountIndex', 'resale', 'preReserved', 'status', 'observation'].indexOf(k) == -1)
                        delete item[k];
                });
                return item;
            });

        let config = {
            correction_rounding: this.indexConfig?.correction_rounding?.id || null,
            correction_index: this.indexConfig?.correction_index?.index_id || null,
            correction_index_date: this.indexConfig?.correction_index?.index_id && this.indexConfig?.correction_index_date?.start || null,
            correction_auto: this.indexConfig?.correction_index?.index_id && this.indexConfig?.correction_index_date?.start && this.indexConfig?.correction_auto? 1 : 0
        };

//        console.log(units, config);
        
        return this.action('save',{
            ad_id: data.ad_id,
            update: data.update,
            unpublish : unpublish,
            owner_person_id : data.owner_person_id,
            ...(!units?.length? {} : {units: units}),
            ...config
            //data : (this.mode == 'readjustment' && this.readjustmentMode == 'index'? {data: {valueReference : data.data?.valueReference, indexReference : data.data?.indexReference}} : {})
        }, result => {
            this.changed.next(false);
            this.gs.message('Disponibilidade atualizada');
            this.data.next({});
            this.gs.transactionData.next({method:'adUpdated', action:'reload'});
            if(nextState)
                this.gs.navigate([nextState.url]);

            return true;
        });
    }
    action(action,data, fthen = null) {
        this.als.setLoaded(false,'availableSave');

        switch(action){
            case 'save':
                return this.httpService.put<any>(API.ad.general.units, data).then(fthen).catch(err => this.gs.error(err)).finally(() => { this.als.setLoaded(true,'availableSave'); });
            case 'pause':
                return this.httpService.put<any>(API.ad.general.pause, data).then(fthen).catch(err => this.gs.error(err)).finally(() => { this.als.setLoaded(true,'availableSave'); });
            case 'cancelpublish':
                return this.httpService.put<any>(API.ad.general.cancel, data).then(fthen).catch(err => this.gs.error(err)).finally(() => { this.als.setLoaded(true,'availableSave'); });

        }
    }

    setData(data){
        this._data = data;
        this.adUtils.data = data.data;
        this.data.next(this._data);
        return data;
    }

    getData(){
        return this.data.getValue();
    }


    getIsChanged(){
        return this.changed.getValue();
    }

    clearChanged(){
        this._data.data.units = this.adUtils.data.units = this.adUtils.data.units.map(item => {
            delete item?.changed;
            return item;
        });
        this.data.next(this._data);        
    }

    setChanged(data){
        
        this.changed.next(data);
    }

   
    private saveUnit(newData) {
        this.changed.next(true);

        newData.changed = true;

        if(this._data.data.units.length==1)
            this.adUtils.data.units = this._data.data.units = [newData];
        else
            this._data.data.units = this.adUtils.data.units = this.adUtils.data.units.map(item => {
                if (item.id == newData.id)
                item = newData;

                return item;
            });

        this.data.next(this._data);
        //    this.setUnitsByFloor();

    }

    convertToFloat(amount){
        return typeof amount == 'string'? parseFloat(amount.replace(/\./g, "").replace(/\,/g, ".")) : amount;
    }
    
    calculateReadjustment(blockSel = 'all', mode, value, index, filters:any = {}){
        let changed = (mode !='index' && value != false) || (mode=='index' && value !=false && index !=false);

        if(changed || (mode=='index' && index!=false)){
            this._data.data.units = this.adUtils.data.units = this.adUtils.data.units.map(unit => {

                if((blockSel == 'all' || blockSel == unit.blockId) && 
                    (!filters?.block?.length || filters?.block.indexOf(parseInt(unit.blockId)) > -1) &&
                    (!filters?.unitType?.length || filters?.unitType.indexOf(parseInt(unit.blockTypeId)) > -1) &&
                    (!filters?.status?.length || filters?.status.indexOf(parseInt(unit.status)) > -1)
                ){
                    let amountFloat = parseFloat(unit.amount);
                    let amountIndexFloat = unit?.amountIndex? parseFloat(unit?.amountIndex) : false;
                    switch(mode){
                        case 'percentage':            
                            unit.amountReadjustment = value !== false? amountFloat + (amountFloat * (value / 100)) : false;
                            if(amountIndexFloat)
                                unit.amountIndexReadjustment = value !== false? amountIndexFloat + (amountIndexFloat * (value / 100)) : false;
                        break;
                        case 'amount':
                            unit.amountReadjustment = value !== false? amountFloat + value : false;
                        break;
                        case 'index':
                            unit.amountIndex = index !== false? amountFloat / index : false;
                            unit.amountReadjustment = value !== false && unit?.amountIndex? unit.amountIndex * value : false;
                        break;
                    }
            
                    unit.changed = unit?.amountReadjustment !== false;
            
                }
                return unit;
                    
                });
            if(mode=='index' && value !=false && index !=false)
                this._data.data.indexReference = this.adUtils.data.indexReference = index;
                
            if(value != false)
                this._data.data.valueReference = this.adUtils.data.valueReference = value;
        }
        
        this.setChanged(changed);

        this.data.next(this._data);
    }

}